var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "161px",
    height: "161px",
    viewBox: "0 0 161 161",
    enableBackground: "new 0 0 161 161",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.5,15.5c-35.84,0-65,29.16-65,65c0,17.55,6.99,33.49,18.34,45.2c2.7,2.79,5.65,5.34,8.82,7.62 c3.66,2.63,7.6,4.89,11.78,6.72c3.37,1.479,6.88,2.69,10.52,3.58c4.98,1.229,10.19,1.88,15.54,1.88c5.75,0,11.33-0.75,16.64-2.16 c3.641-0.96,7.16-2.24,10.521-3.79c4.92-2.27,9.51-5.14,13.68-8.52c3.05-2.471,5.87-5.21,8.43-8.181 c9.801-11.38,15.73-26.189,15.73-42.35C145.5,44.66,116.34,15.5,80.5,15.5z M124.33,113.69c-2.311,3.05-4.94,5.859-7.84,8.359 c-3.681,3.2-7.79,5.91-12.23,8.05c-3.33,1.601-6.84,2.881-10.5,3.78c-4.25,1.061-8.689,1.62-13.26,1.62 c-3.84,0-7.59-0.4-11.21-1.15c-3.77-0.779-7.4-1.949-10.84-3.47c-4.02-1.76-7.79-4-11.24-6.63c-3.03-2.31-5.82-4.92-8.31-7.81 C30.56,106.8,25.5,94.22,25.5,80.5c0-30.33,24.67-55,55-55s55,24.67,55,55C135.5,92.95,131.34,104.46,124.33,113.69z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.26,130.1c-1.14-2.449-2.479-4.83-4-7.119L82.05,95.64L61.13,126.49c-0.97,1.43-1.87,2.899-2.68,4.39 c-1.64,2.95-1.95,2.881-2.98,6.021c3.37,1.479,6.899,2.62,10.54,3.51c1.05-3.21,1.45-3.11,3.28-6.061 c0.32-0.54,0.67-1.08,1.03-1.609l11.65-17.19l9.05,13.59c1.021,1.53,1.931,3.11,2.74,4.74c1.51,3.03,1.153,1.167,1.893,4.417 c3.641-0.96,7.808-0.427,11.168-1.977C105.98,133.091,105.69,133.15,104.26,130.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.667,121.333c2.67-4.301,8.943-13.303,12.324-17.193L68.52,80.5v10.03c0,4.46-1.61,8.76-4.53,12.13l-7.62,8.77 c-3.49,4.021-8.25,11.261-10.87,15.761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.333,122.333c-2.56,2.971-1.283,2.387-4.333,4.857c-1.42-3.08-2.7-2.23-4.51-5.141c-2.311-3.7-4.92-7.26-7.84-10.62 h-0.011l-7.609-8.77c-2.92-3.37-4.53-7.67-4.53-12.13V80.5l20.52,23.64c2.65,3.051,5.091,6.24,7.311,9.551 C126.32,116.65,123.703,119.193,125.333,122.333z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 8.9006,
    cx: 82.301,
    cy: 62.301,
    r: 13.351
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.b4bdddc178b9133079f14a20b9475dd0.svg";
export { ForwardRef as ReactComponent };